module.exports = __webpack_public_path__ + "static/media/headersection.8f8294fb.png";